import styled from 'styled-components';
import { darken } from 'polished';

import RawCheckmark from 'images/icons/empty-checkmark.inline.svg';
import { getDimension } from 'styled/helpers/getDimension';

import type { Highlight } from 'styled/types';

export const Checkmark = styled(RawCheckmark)<{ color?: Highlight }>`
  margin-left: ${getDimension('size4')};
  stroke: black;
  stroke: ${({ theme, color }) => color && darken(0.15, theme.colors[color])};
`;
